

import { Card, CardActionArea, CardContent, CardMedia, Container, Typography } from '@mui/material';
import { appUrl, Lang } from 'cdx-common';
import { useNavigate } from 'react-router-dom';
import { useSession } from './libraries/SessionProvider';
import { MasterViewPage } from './views/MasterPage';
import { MainPage } from './website/main';


export const HomeView = () => {
    const { user } = useSession();
    return !!user ? <MasterViewPage><LoggedView /></MasterViewPage> : <NotLoggedView />;
};

const NotLoggedView = () => {
    return <MainPage />;
};

const LoggedView = () => {


    const { isSuperAdmin } = useSession();
    return <>
        <Container
            maxWidth={false}
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'flex-start',
                gap: 3,
                py: 3
            }}
        >
            <HomeCard image='/assets/employes.png' href={appUrl('users')} title={Lang('users', { ucf: true })} desc='La liste des employés' />
            <HomeCard image='/assets/prise_inventaire.png' href={appUrl('scanProductsMode')} title={Lang('titrePriseInventaire', { ucf: true })} desc='Codes à barres, entrepôts, produits, etc.' />
            <HomeCard image='/assets/etiquetage.png' href={appUrl('labeler')} title={Lang('titleEtiqueteuse', { ucf: true })} desc='Créer des étiquettes pour impression en lot' />
            {isSuperAdmin && <HomeCard image='/assets/parametres.png' href={appUrl('parametres')} title={Lang('parametres', { ucf: true })} desc="Accéder aux paramètres de l'environnement" />}
        </Container>
    </>;
};


const HomeCard = (props: {
    image: string,
    href: string,
    title: string,
    desc: string;
}) => {
    const navigate = useNavigate();
    const onClick = () => {
        navigate(props.href);
    };
    return <Card sx={{ width: '100%', maxWidth: 345 }}>
        <CardActionArea onClick={onClick}>
            <CardMedia
                component="img"
                height="140"
                image={props.image}
                alt="green iguana"
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {props.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {props.desc}
                </Typography>
            </CardContent>
        </CardActionArea>
    </Card>;
};
